import { Backend } from '@/_axios';

/**
 * Created by marcis on 18.3.10.
 */
export default {
  SAVE_MONTH_REVENUE: function ({ commit, state }, data) {
    Backend.post('/api/save-month-revenue', data).then((response) => {
      if (data.revenue == 0 || !data.revenue) {
        commit('DELETE_MONTH_REVENUE', { revenueDate: data.date, revenueProject: data.project_id, message: response.data.data.message });
      }
      if (data.revenue > 0) {
        commit('SAVE_MONTH_REVENUE', { data: response.data.data.data, message: response.data.data.message });
      }
    }, (err) => {
      console.log(err.response);
      commit('SET_ERROR_MESSAGES', { messages: err.response.data.messages });
    });
  },
  LOAD_REVENUE_PER_MONTH: function ({ commit, state }) {
    Backend.get('/api/all-revenues-per-month').then((response) => {
      commit('SET_ALL_REVENUE_DATA', response.data);
    });
  },
  LOAD_PROJECT_REVENUE_PER_MONTH: function ({ commit, state }, { id }) {
    Backend.get('/api/project-revenues-per-month', { params: { id: id } }).then((response) => {
      commit('SET_ALL_REVENUE_DATA', response.data);
    });
  }
};
